import { FC, ReactNode } from "react";
import { Flex, Box, Text, useMantineTheme } from "@mantine/core";

interface SectionTitleProps {
  children: ReactNode;
  color?: string;
}

export const SectionTitle: FC<SectionTitleProps> = ({ children, color }) => {
  const theme = useMantineTheme();
  const barColor = color ?? theme.colors.fwcBlue?.[6] ?? theme.colors.blue[6];

  return (
    <Flex align="center" gap="xs">
      <Box
        w={4}
        h={20}
        bg={barColor}
        style={{ borderRadius: 2, flexShrink: 0 }}
      />
      <Text fw={700} size="lg">
        {children}
      </Text>
    </Flex>
  );
};
